import {
  UPDATE_URL,
  RESET_URL
} from "../../actionTypeConstants/ml2.0/testDetailUrlPersist";

const initialState = {
  url: {
    home: ""
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_URL: {
      return {
        ...state,
        url: { ...state.url, [action.payload.tab]: action.payload.url }
      };
    }

    case RESET_URL: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}
